import script from "./cycles.vue?vue&type=script&setup=true&lang=js"
export * from "./cycles.vue?vue&type=script&setup=true&lang=js"

import "./cycles.vue?vue&type=style&index=0&id=5066a35e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5066a35e"]])

export default __exports__